<template>
  <div class="actareas" :class="{ showact: showact }">
    <!-- 在线抢购 -->
    <div class="center_btns onlyzp c2" v-if="isShowQiangGou">
      <img
        src="https://assets.rurushishi.com/yq-rs-make/t7/btn_dianjiqianggou.png"
        alt
        @click="clickGoQiangGou"
      />
    </div>
    <!-- 活动区配置 -->
    <div
      class="center_btns onlyzp c2"
      v-if="isShowBuyCoupon && isShowLaunchWeapp"
      v-html="htmlWxOpenLaunchWeappBuy"
    ></div>
    <div class="center_btns onlyzp c2" v-else-if="isShowBuyCoupon">
      <img v-lazy="coupon_banner_img" alt @click="clickBuyCoupon" />
    </div>

    <div
      class="center_btns onlyzp c2"
      v-if="isShowGetCoupon && isShowLaunchWeapp"
      v-html="htmlWxOpenLaunchWeappFee"
    ></div>
    <div class="center_btns onlyzp c2" v-else-if="isShowGetCoupon">
      <img v-lazy="getcoupon1_banner_img" alt @click="clickGetCoupon" />
    </div>
    <div
      class="center_btns onlyzp c2"
      v-if="
        (isShowGoAct && isShowLaunchWeapp && isShowGoActMp) || isLianShiLive
      "
      v-html="htmlWxOpenLaunchWeappAct"
    ></div>
    <div class="center_btns onlyzp c2" v-else-if="isShowGoAct">
      <img v-lazy="getcoupon3_banner_img" alt @click="clickGoAct" />
    </div>
    <div class="center_btns onlyzp c2" v-if="isShowGoOnline">
      <img v-lazy="getonline_banner_img" alt @click="clickGoOnline" />
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import wx from "weixin-js-sdk";
export default {
  components: {},
  props: {},
  data() {
    return {
      showact: false,
      // 在线抢购
      isShowQiangGou: false,
      //活动区配置
      isShowBuyCoupon: false,
      coupon_banner_img: "",
      isShowGetCoupon: false,
      getcoupon1_banner_img: "",
      isShowGoAct: false,
      isShowGoActMp: false,
      getcoupon3_name_mp: "",
      getcoupon3_banner_img: "",
      isShowGoOnline: false,
      getonline_banner_img: "",
      isLianShiLive: false,
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "pageInfo",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "userInfo",
    ]),
    isShowLaunchWeapp() {
      return util.checkIsHuafa();
    },
    htmlWxOpenLaunchWeappBuy() {
      let script = document.createElement("script");
      script.type = "text/wxtag-template";
      script.text = `${util.getMediaCssTxt()}<img src="${
        this.coupon_banner_img
      }" style="width: 94%;height:1.15rem;margin-left: 3%;"/>`;
      let html = `<wx-open-launch-weapp style="width:100%;height:1.15rem;display:block;" username="${util.getOriginalId()}" path="${util.getXcxActAreasPath(
        this,
        "buy"
      )}">${script.outerHTML}</wx-open-launch-weapp>`;
      return html;
    },
    htmlWxOpenLaunchWeappFee() {
      let script = document.createElement("script");
      script.type = "text/wxtag-template";
      script.text = `${util.getMediaCssTxt()}<img src="${
        this.getcoupon1_banner_img
      }" style="width: 94%;height:1.15rem;margin-left: 3%;"/>`;
      let html = `<wx-open-launch-weapp style="width:100%;height:1.15rem;display:block;" username="${util.getOriginalId()}" path="${util.getXcxActAreasPath(
        this,
        "free"
      )}">${script.outerHTML}</wx-open-launch-weapp>`;
      return html;
    },
    htmlWxOpenLaunchWeappAct() {
      let script = document.createElement("script");
      script.type = "text/wxtag-template";
      script.text = `${util.getMediaCssTxt()}<img src="${
        this.getcoupon3_banner_img
      }" style="width: 94%;height:1.15rem;margin-left: 3%;"/>`;
      let html = `<wx-open-launch-weapp style="width:100%;height:1.15rem;display:block;" username="${util.getOriginalId()}" path="${util.handleH5OpenMpPath(
        this.getcoupon3_name_mp
      )}">${script.outerHTML}</wx-open-launch-weapp>`;
      return html;
    },
  },
  methods: {
    // lj19
    clickGoQiangGou() {
      // 在线抢购，在线抢房
      let url = this.pageInfo.Extinfo.houseOnlineConfig.url;
      url = `${location.protocol}//${location.host}/marketies/onlinerecognition/index?pid=${this.pageInfo.Extinfo.houseOnlineConfig.projectId}`;
      util.openOtherLink(url);
    },
    // lj16
    clickBuyCoupon() {
      //优惠购
      let url = `${location.protocol}//${location.host}/h5/coupon?ctype=buy`;
      util.openYqRsMakeLink(url);
    },
    // lj17
    clickGetCoupon() {
      //优惠券
      let url = `${location.protocol}//${location.host}/h5/coupon?ctype=get`;
      util.openYqRsMakeLink(url);
    },
    // lj18
    clickGoAct() {
      //自定义配置活动
      if (
        this.pageInfo.Extinfo.actConfig &&
        this.pageInfo.Extinfo.actConfig.open_getcoupon3 == 1 &&
        this.pageInfo.Extinfo.actConfig.getcoupon3_name
      ) {
        let url = this.pageInfo.Extinfo.actConfig.getcoupon3_name;
        if (
          util.checkIsLianShi() &&
          url.indexOf("pages/custom/lianshi/live/live") > -1
        ) {
          wx.miniProgram.redirectTo({
            url: `/pages/custom/lianshi/live/live`,
          });
        } else {
          util.openOtherLink(url);
        }
      }
    },
    clickGoOnline() {
      //在线认购
      let url = `${location.protocol}//${location.host}/h5/huafasubscription/housePage?pid=${this.pageInfo.Pid}`;
      util.openYqRsMakeLink(url);
    },
  },
  created() {
    util
      .checkMapStateCallback(this, [
        "pageInfo",
        "userInfo",
        "receiveSpreadInfo",
      ])
      .then(() => {
        // 判断在线抢购 非华发
        if (!util.checkIsHuafa()) {
          if (
            this.pageInfo.Extinfo.houseOnlineConfig &&
            this.pageInfo.Extinfo.houseOnlineConfig.projectId
          ) {
            this.isShowQiangGou = true;
          }
        }
        //判断活动区配置
        if (
          this.pageInfo.Extinfo.actConfig &&
          this.pageInfo.Extinfo.actConfig.open_coupon == 1 &&
          this.pageInfo.Extinfo.actConfig.coupon_banner_img
        ) {
          this.showact = true;
          //配置了优惠购
          this.isShowBuyCoupon = true;
          this.coupon_banner_img = this.pageInfo.Extinfo.actConfig.coupon_banner_img;
        }
        if (
          this.pageInfo.Extinfo.actConfig &&
          this.pageInfo.Extinfo.actConfig.open_getcoupon1 == 1 &&
          this.pageInfo.Extinfo.actConfig.getcoupon1_banner_img
        ) {
          this.showact = true;
          //配置了优惠券
          this.isShowGetCoupon = true;
          this.getcoupon1_banner_img = this.pageInfo.Extinfo.actConfig.getcoupon1_banner_img;
        }
        if (
          this.pageInfo.Extinfo.actConfig &&
          this.pageInfo.Extinfo.actConfig.open_getcoupon3 == 1 &&
          this.pageInfo.Extinfo.actConfig.getcoupon3_banner_img
        ) {
          util.getIsInMiniProgram().then((isInMiniProgram) => {
            let url = this.pageInfo.Extinfo.actConfig.getcoupon3_name;
            if (
              util.checkIsLianShi() &&
              url.indexOf("pages/custom/lianshi/live/live") > -1 &&
              !isInMiniProgram
            ) {
              // wx.miniProgram.redirectTo({
              //   url: `/pages/custom/lianshi/live/live`,
              // });
              this.isShowGoActMp = true;
              this.getcoupon3_name_mp = this.pageInfo.Extinfo.actConfig.getcoupon3_name;
              this.getcoupon3_banner_img = this.pageInfo.Extinfo.actConfig.getcoupon3_banner_img;
              this.isLianShiLive = true;
            } else {
              this.showact = true;
              //配置了自定义活动
              this.isShowGoAct = true;
              if (this.pageInfo.Extinfo.actConfig.getcoupon3_name_mp) {
                this.isShowGoActMp = true;
                this.getcoupon3_name_mp = this.pageInfo.Extinfo.actConfig.getcoupon3_name_mp;
              }
              this.getcoupon3_banner_img = this.pageInfo.Extinfo.actConfig.getcoupon3_banner_img;
            }
          });
        }
        if (
          this.pageInfo.Extinfo.actConfig &&
          this.pageInfo.Extinfo.actConfig.open_getonline == 1 &&
          this.pageInfo.Extinfo.actConfig.getonline_banner_img
        ) {
          this.showact = true;
          //配置了自定义活动
          this.isShowGoOnline = true;
          this.getonline_banner_img = this.pageInfo.Extinfo.actConfig.getonline_banner_img;
        }
        // if (util.checkIsHuafa() && this.isInMiniProgram) {
        //   //华发小程序不展示优惠购
        //   this.isShowBuyCoupon = false;
        // }
      });
  },
  mounted() {},
};
</script>
<style lang="css" scoped>
.showact {
  margin: 0.2rem 0;
}
.center_btns {
  width: 96%;
  display: flex;
  justify-content: space-around;
  margin: 0.1rem auto 0 auto;
  height: 1.15rem;
}
.center_btns > img {
  width: 94%;
  height: 1.15rem;
}
</style>